import React from "react";
import "./AssistantFab.css";

export default function AssistantFab({ onClick, hidden }) {
  if (hidden) return null;
  return (
    <div className="assistant-fab-container">
      <button type="button" className="assistant-fab-main" onClick={onClick} aria-label="Open assistant">
        <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </button>
    </div>
  );
}
